import * as TYPES from './types';
export default {
    [TYPES.SET_ORIGIN_DEMOGRAPHICS](payload) {
        this.originDemographics = payload;
    },

    async [TYPES.FETCH_ORIGIN_DEMOGRAPHICS](hjId) {
        let url = '/api-site/geographic/nbr/' + hjId;
        let data = await this.axiosIns.get(url);
        this[TYPES.SET_ORIGIN_DEMOGRAPHICS](data.data?.demographics || {});
    }
};
